
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal/conversion-history",
      function () {
        return require("private-next-pages/portal/conversion-history.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal/conversion-history"])
      });
    }
  